// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import moment from 'moment/moment'
import store from '../store'
import '../src/assets/scss/index.css'
import {Auth} from './api/login'
Vue.config.productionTip = false

Vue.use(ElementUI)
/* eslint-disable no-new */
// 时间过滤
Vue.filter('formatDate', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD HH:mm:ss'
  return value ? moment.unix(value / 1000).format(formatString)
    : ''
})

// 数组取值
Vue.filter('arrayGetValue', function (value, resultArray) {
  return resultArray[value]
})

// 日期天数差
Vue.filter('dateDiffDay', function (value) {
  let currDay = 24 * 60 * 60 * 1000
  let currTime = Date.now()
  let dayNum = (currTime - value) / currDay
  return parseInt(dayNum)
})

// 路由拦截
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 后台管理员登陆的情况
  let userLoginState = false
  if (localStorage.getItem('userInfo')) {
    userLoginState = true
    store.commit('setUserInfo', JSON.parse(localStorage.getItem('userInfo')))
  }
  if (to.name === 'login') {
    if (userLoginState && Object.keys(to.query).length === 0) {
      setTimeout(() => {
        next({name: 'index'})
      }, 1000)
    } else {
      next()
    }
  } else {
    if (userLoginState) {
      next()
    } else {
      next({name: 'login'})
    }
  }
})
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    this.ipVerify()
  },
  methods: {
    ipVerify () {
      Auth().then(res => {
        if (res.status !== 2000) {
          window.location.href = 'about:blank'
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js